import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useW4Locks = (options = {}) => {
  const context = useAuthContext();
  const { loading, data } = useQuery(Queries.getMyW4Locks, {
    context,
    ...options,
  });
  return { loading, data: data && data.getCurrentUser.w4Locks };
};

export default useW4Locks;
